document.addEventListener('DOMContentLoaded', function () {

  const mediumSizeInput = document.querySelector(
    '.variant-option input[type="radio"][value="M"][data-option-available="true"]'
  );

  if (!mediumSizeInput) return;

  mediumSizeInput.checked = true;

  mediumSizeInput.dispatchEvent(
    new Event('change', { bubbles: true })
  );

});